import React from 'react';
import { Popover } from 'antd';
import {  PLATFORM_THEME_COLORS, Typography } from '@thinknet-gmbh/platform-common-ui';
import { ProcessTaskAssignEnum } from '@thinknet-gmbh/platform-common';

import { useGetJobById } from 'src/hooks/jobs/get-job-by-id.hook';
import { useGetCompanyById } from 'src/hooks/companies/get-company-by-id.hook';
import { useGetMembersByIds } from 'src/hooks/members/get-members-by-Ids.hook';

import { IProcessTask } from 'src/pages/tasks-manager/task-manager.interfaces';

import {
  AssignToDetailsWrapper,
  AssignToRow,
  PopoverContentWrapper,
} from '../../process-tasks-table.styles';

const PopoverComponent = ({ text }: { text: string }) => (
  <AssignToDetailsWrapper>
    <Popover
      arrowPointAtCenter
      placement="topRight"
      trigger="hover"
      title={''}
      content={
        <PopoverContentWrapper>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{text}</Typography>
        </PopoverContentWrapper>
      }
    >
      <AssignToRow>{text}</AssignToRow>
    </Popover>
  </AssignToDetailsWrapper>
);

const AssignToDetails = ({
  responsiblePersonsIds,
  jobId,
  companyId,
  departmentId,
  assignTo,
}: IProcessTask) => {
  const { company } = useGetCompanyById(companyId);
  const { job } = useGetJobById(jobId);

  const { employees } = useGetMembersByIds({ membersId: responsiblePersonsIds });

  if (assignTo === ProcessTaskAssignEnum.PERSONS) {
    const members = employees
      ?.map(({ profile }: any) => {
        return profile?.displayName;
      })
      .join(', ');

    return <PopoverComponent text={members} />;
  }
  if (assignTo === ProcessTaskAssignEnum.DEPARTMENT) {
    const department = company?.departments?.find(
      ({ _id }: { _id: string; name: string }) => String(departmentId) === String(_id)
    );
    return <PopoverComponent text={`${company?.name}, ${department?.name}`} />;
  }
  if (assignTo === ProcessTaskAssignEnum.JOB) {
    return <PopoverComponent text={job?.title} />;
  }
  return <AssignToRow>-</AssignToRow>;
};

export default AssignToDetails;
